import React, { Component } from "react";
import PropTypes from 'prop-types';
import styled from "styled-components";
import AceEditor from "react-ace";
import "brace/mode/javascript";
import "./streamTheme";

// Components //
import Button from 'components/Button';
import View from "components/View";

/*eslint-disable */
const Root = styled(View)`
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  box-shadow: 0 0 16px 0 rgba(0,0,0,0.09);
`;

const Run = styled(Button)`

`;

const Actions = styled(View)`
  padding: 10px 8px;
  background-color: ${ ({ theme }) => theme.color.dark };
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;
/*eslint-enable */

class CodeEditor extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    onRunClick: PropTypes.func,
    runLabel: PropTypes.string,
    value: PropTypes.string,
  };

  static defaultProps = {
    runLabel: 'Run'
  }

  render() {
    const { onChange, onRunClick, value, runLabel } = this.props;

    return (
      <Root>
        <AceEditor
          mode="javascript"
          theme="getstream"
          name="Stream Chat – Getting Started"
          onLoad={this.onLoad}
          onChange={onChange}
          fontSize={12}
          showPrintMargin={true}
          showGutter={false}
          highlightActiveLine={false}
          style={{ width: "100%", height: 280, zIndex: 1 }}
          value={value}
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: false,
            showLineNumbers: false,
            tabSize: 2
          }}
        />
        {onRunClick && <Actions>
          <Run onClick={onRunClick} label={runLabel} />
        </Actions>}
      </Root>
    );
  }
}

export default CodeEditor;
